export const IUserApplicationRepositoryType = Symbol('IUserApplicationRepository');
